import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'login/:id/:token',
        component: LoginComponent,
    },
    {
        path: '',
        loadChildren: () => import('./cabinet/cabinet.module').then(mod => mod.CabinetModule)
    },
    {
        path: 'cabinet/:id',
        loadChildren: () => import('./cabinet/cabinet.module').then(mod => mod.CabinetModule)
    },
    {
        path: 'tracking/:token',
        loadComponent: () => import('./tracking-component/tracking-component.component').then(cmp => cmp.TrackingComponentComponent)
    },
    {
        path: '**',
        redirectTo: '',
    },
];
